import React from 'react';
import { connect } from 'react-redux';
import toastMessageActions from 'jd-library/toastMessageActions';
import FormSwitch from 'jd-library/FormSwitch';
import { Regex, scrollIntoView, isBeyondRange } from '../../../utills.js';
import InputGroup from 'jd-library/InputGroup';
import ToggleBtnGroup from 'jd-library/ToggleBtnGroup';

import style from './price-range-qty.scss';

class PriceRangeQty extends React.Component {
    constructor(props) {
        super(props);
        let defaultprice = this.props.defaultPrice || '';
        this.emptyData = {
            disabled : false,
            minimumQuantity: this.props.variantPresent ? 1 : "",
            maximumQuantity: "",
            fixedDiscount: "",
            percentageDiscount: "",
            sellingPrice: this.props.variantPresent ? 0 : defaultprice
        };
        this.state = {
            sellOnlineFormData: [{ ...this.emptyData }],
            discToggleIndex: this.props.variantPresent ? 1 : 0,
            showErrors: false,
            slideRangeUp: false,
            slideUp: false,
            errors:{},
            maxQtyNotApplicable: false
        }
        this.discountTypes = ['fixedDiscount', 'percentageDiscount'];
        this.inputGroups = this.inputGroups.bind(this);
        this.addRange = this.addRange.bind(this);
        this.updateValue = this.updateValue.bind(this);
        this.verifyRanges = this.verifyRanges.bind(this);
        this.calcEffectiveSP = this.calcEffectiveSP.bind(this);
        this.checkError = this.checkError.bind(this);
        this.clearErrors = this.clearErrors.bind(this);
        this.rangeChangeHandler = this.rangeChangeHandler.bind(this);
        this.deleteRange = this.deleteRange.bind(this);
        this.updateAllSp = this.updateAllSp.bind(this);
        this.formSwitchHandler = this.formSwitchHandler.bind(this);
    }

    componentDidMount() {
        this.props.onRef(this);
        let priceObj=this.props.productData?.priceObj
        if (this.props.viaOmni ) {
            let isMaxQtyNotApplicableForRange=null
            if (this.props.productData?.bulkPricingDetail?.length > 0 && this.props.productData?.isSellOnline){
                priceObj = {
                    priceOnQty: this.props.productData?.bulkPricingDetail?.map(data => {
                        isMaxQtyNotApplicableForRange=data?.disabled // last node value
                        return {
                            "minVisit": data?.minimumQuantity,
                            "maxVisit": data?.maximumQuantity,
                            "price": data?.sellingPrice,
                            "discountType": data?.percentageDiscount != null ? "percentageDiscount" : 'fixedDiscount',
                            "discountValue": data?.percentageDiscount || data?.fixedDiscount,
                            "disabled": data?.disabled,
                        }
                    })
                }
            }else if (this.props.productData?.bulkPricingDetail?.length == 0 && this.props.productData?.isSellOnline){
                priceObj = {
                    priceOnQty: this.props.productData?.priceObj?.priceOnQty?.map(data => {
                        isMaxQtyNotApplicableForRange=data?.disabled // last node value
                        return {
                            "minVisit": '',
                            "maxVisit": '',
                            "price": '',
                            "discountType": '',
                            "discountValue": '',
                            "disabled": '',
                        }
                    })
                }
            }else {
                priceObj = {
                    priceOnQty: this.props.productData?.priceObj?.priceOnQty?.map(data => {
                        isMaxQtyNotApplicableForRange=data?.disabled // last node value
                        return {
                            "minVisit": data?.minVisit,
                            "maxVisit": data?.maxVisit,
                            "price": data?.price,
                            "discountType": data?.discountType,
                            "discountValue": data?.discountValue,
                            "disabled": data?.disabled,
                        }
                    })
                }
            }
            priceObj.isMaxQtyNotApplicableForRange=isMaxQtyNotApplicableForRange
        }
        if(priceObj?.priceOnQty?.length){
            let newPriceObj = {...priceObj};
            let dummyArr = [...newPriceObj.priceOnQty];
            let dummySwitch = dummyArr[0].discountType == 'percentageDiscount' && dummyArr[0].discountValue ? 1 : 0;
            let dummySellOnlineArr = [];
            let maxQtyNotApplicable=newPriceObj.isMaxQtyNotApplicableForRange ? true : false
            dummyArr?.forEach((cur,index)=>{
				let dummyObj = {};let sellingPrice;
                if(!this.props.variantPresent) {
                    if (cur.discountType == 'fixedDiscount') {
                        sellingPrice = Number(this.props.defaultPrice) - Number(cur.discountValue);
                    }
                    else {
                        sellingPrice = Number(this.props.defaultPrice) * ((100 - Number(cur.discountValue)) / 100);
                    }
                }                
				dummyObj.minimumQuantity = cur.minVisit;
				dummyObj.maximumQuantity = cur.maxVisit;
                let defaultPrice = this.props?.defaultPrice ? sellingPrice?.toFixed(2): '';
				dummyObj.sellingPrice = this.props?.variantPresent ? 0 : defaultPrice;
				dummyObj.fixedDiscount = cur.discountType == 'fixedDiscount' ? cur.discountValue : '';
                dummyObj.percentageDiscount = cur.discountType == 'percentageDiscount' ? cur.discountValue : '';
                dummyObj.disabled = cur.disabled;
				dummySellOnlineArr.push(dummyObj);
                if (this.props.viaOmni) {
                    maxQtyNotApplicable=cur.disabled // last disabled value
                }
			});
           
            
            this.setState({
                maxQtyNotApplicable: maxQtyNotApplicable,
                sellOnlineFormData : dummySellOnlineArr,
                discToggleIndex : dummySwitch
            },()=>{
                this.props.updateSellOnlineFormData(this.state.sellOnlineFormData,"init");
            })
        }else{
            this.updateAllSp();
        }
        let errorKeys = ['minimumQuantity', 'maximumQuantity', 'fixedDiscount', 'percentageDiscount'];
        for (let i = 0; i < errorKeys.length; i++) {
            this.clearErrors(errorKeys[i], 0);
        }
    }
    // componentDidUpdate(prevProps) {
    //     if(this.props.defaultPrice !== prevProps.defaultPrice)
    //     {
    //         this.updateAllSp();
    //     }
    //   } 
    
    updateValue(e, value) {
        if(this.state.discToggleIndex == value){
            return;
        }
        this.setState({
            discToggleIndex: value
        });
        let currentState = this.state.sellOnlineFormData;
        currentState.map((cur) => {
            if (value == 0) {
                cur.fixedDiscount = cur.percentageDiscount;
                cur.percentageDiscount = null;
            } else {
                cur.percentageDiscount = cur.fixedDiscount;
                cur.fixedDiscount = null;
            }
        })
        this.setState({ sellOnlineFormData: currentState });
        this.props.updateSellOnlineFormData(currentState);
        [0, 1, 2, 3].map((i) => {
            this.calcEffectiveSP(i, (value == 0 ? 'fixedDiscount' : 'percentageDiscount'),null,true);
        })
    }

    addRange() {
        const checkError = this.verifyRanges();
        if(this.props?.handleRangeOnMinQty){
            const checkMinQtyError = this.props.handleRangeOnMinQty();
            if(checkMinQtyError) {
                return true;
            }
        }
        
        if(checkError){
            this.props.showToastMessage({
                showToastMessage: true,
                message: checkError,
                type: 'error',
                duration: 5000
            });
            return;
        }
        let concatData = [{ ...this.emptyData }];
        let formDataTemp = this.state.sellOnlineFormData;
        let LastMinQty = formDataTemp[formDataTemp.length -1]['maximumQuantity'];
        if (this.props.defaultPrice && !this.props.variantPresent){
            concatData[0]['sellingPrice'] = this.props.defaultPrice ? Number(this.props.defaultPrice).toFixed(2): '';
        }
        LastMinQty = LastMinQty ? parseInt(LastMinQty) + 1 : 1
        concatData[0]['minimumQuantity'] = LastMinQty.toString();
        for(let i=0; i <= formDataTemp.length - 1; i++){
            formDataTemp[i]['disabled'] = true   
        }
        formDataTemp = formDataTemp.concat(concatData);
        if (this.state.sellOnlineFormData.length < 4) {
            this.setState({
                sellOnlineFormData: formDataTemp
            });
            this.props.updateSellOnlineFormData(formDataTemp);
        }
    }

    rangeChangeHandler(e, index, key) {
        let tempVal = '';
        e.currentTarget.value = e.currentTarget.value.replace(/[^0-9.]/g, "");
         if (e.currentTarget.value === "." && e?.nativeEvent?.data === ".") {
            e.currentTarget.value = "";
            return;
        }
        let quantityRegex = /^\d{0,8}$/ 
        if (typeof (e.currentTarget.value) == "string" && !Regex.priceRegex.test(e.currentTarget.value) && this.discountTypes.includes(key)) {
            e.currentTarget.value = e.currentTarget.value.slice(0, -1);
        }
        if (typeof (e.currentTarget.value) == "string" && !quantityRegex.test(e.currentTarget.value) && (key == 'minimumQuantity' || key == 'maximumQuantity')) {
            e.currentTarget.value = e.currentTarget.value.slice(0, -1);
        }
        if (typeof (e.currentTarget.value) != "string") {
            tempVal = "" + e.currentTarget.value;
            if (!Regex.priceRegex.test(tempVal) && this.discountTypes.includes(key)) {
                tempVal = tempVal.slice(0, -1);
                tempVal = Number(tempVal);
                if (!isNaN(tempVal)) {
                    e.currentTarget.value = tempVal;
                }
            }
            if (!quantityRegex.test(tempVal) && (key == 'minimumQuantity' || key == 'maximumQuantity')) {
                tempVal = tempVal.slice(0, -1);
                tempVal = Number(tempVal);
                if (!isNaN(tempVal)) {
                    e.currentTarget.value = tempVal;
                }
            }
        }
        var formDataTemp = this.state.sellOnlineFormData;
        formDataTemp[index][key] = e.currentTarget.value;
        this.setState({ sellOnlineFormData: formDataTemp });
        this.props.updateSellOnlineFormData(formDataTemp);
        this.clearErrors(key, index);
        if (this.discountTypes.includes(key)) {
            this.calcEffectiveSP(index, key);
        }
    }

    handleMaxQtySwitch=()=>{
        this.setState({maxQtyNotApplicable : !this.state.maxQtyNotApplicable},()=>{
            this.props.handleMaxQty(this.state.maxQtyNotApplicable);
        });
        let isMaxQty = !this.state.maxQtyNotApplicable;
        if(isMaxQty){
            let formDataTemp = this.state.sellOnlineFormData;
            formDataTemp[formDataTemp.length - 1]['maximumQuantity'] = '-1';
            formDataTemp[formDataTemp.length - 1]['disabled'] = true;
            this.setState({ sellOnlineFormData: formDataTemp });
            this.props.updateSellOnlineFormData(formDataTemp);
        }else{
            let formDataTemp = this.state.sellOnlineFormData;
            formDataTemp[formDataTemp.length - 1]['maximumQuantity'] = '';
            formDataTemp[formDataTemp.length - 1]['disabled'] = false;
            this.setState({ sellOnlineFormData: formDataTemp });
            this.props.updateSellOnlineFormData(formDataTemp);
        }
    }

    clearErrors(key, index) {
        let errorObj = {};
        if (key == 'minimumQuantity' || key == 'maximumQuantity') {
            errorObj = this.state.errors.minVsMaxError || [];
            for (let i = 0; i < errorObj.length; i++) {
                if (errorObj[i]['index'] == index) {
                    errorObj.splice(i, 1);
                }
            }
            errorObj = this.state.errors.noMinQty || [];
            for (let i = 0; i < errorObj.length; i++) {
                if (errorObj[i]['index'] == index && key == 'minimumQuantity') {
                    errorObj.splice(i, 1);
                }
            }
            errorObj = this.state.errors.noMaxQty || [];
            for (let i = 0; i < errorObj.length; i++) {
                if (errorObj[i]['index'] == index && key == 'maximumQuantity' ) {
                    errorObj.splice(i, 1);
                }
            }
            errorObj = this.state.errors.qtyRangeError || [];
            for (let i = 0; i < errorObj.length; i++) {
                if (errorObj[i]['index'] == index) {
                    errorObj.splice(i, 1);
                }
            }
        }
        else if (key == 'fixedDiscount' || key == 'percentageDiscount') {
            errorObj = this.state.errors.negSPError || [];
            for (let i = 0; i < errorObj.length; i++) {
                if (errorObj[i]['index'] == index && !this.props.toleranceErrMsg) {
                    errorObj.splice(i, 1);
                    this.props.setToleranceErrMsg('');
                }
            }
            errorObj = this.state.errors.noDiscount || [];
            for (let i = 0; i < errorObj.length; i++) {
                if (errorObj[i]['index'] == index) {
                    errorObj.splice(i, 1);
                }
            }
            
        }
        this.setState({showErrors: this.state.showErrors})
    }
    
    verifyRanges(forTolerance=0, minValue=0, maxValue=0) {
        let formData = this.state.sellOnlineFormData;
        let minQty, maxQty, minVsMaxErrorObj = [], qtyRangeErrorObj = [], negSPErrorObj = [], noMaxQtyObj = [], noMinQtyObj = [], noDiscountObj = [], noError = '';
        for (let i = formData.length - 1; i >= 0; i--) {
            if (forTolerance==1) {
                if (isBeyondRange(formData[i].sellingPrice , minValue, maxValue)) { 
                    negSPErrorObj.push({ index: i, errorMessage: ' ' });
                }
            } else {
                if(!this.props.variantPresent) {
                    if (formData[i].sellingPrice == 0 || (formData[i].sellingPrice && (formData[i].sellingPrice <= 0))) {
                        negSPErrorObj.push({ index: i, errorMessage: 'Quantity Should be in Ascending Order' });
                        noError = 'Discounted Price Should be Greater than 0';
                    }
                }
                if(this.state.discToggleIndex == 0 ? !formData[i]['fixedDiscount'] : !formData[i]['percentageDiscount']){
                    noDiscountObj.push({ index: i, errorMessage: 'Please Enter Discount' });
                    noError = 'Please Enter Discount';
                }
                if (!formData[i]['maximumQuantity']) {
                    noMaxQtyObj.push({ index: i, errorMessage: 'Max. Qty. is required' });
                    noError = 'Please Enter Maximum Quantity';
                }
                if (formData[i]['minimumQuantity'] === '0') {
                    noMinQtyObj.push({ index: i, errorMessage: 'Minimum Quantity Cannot be 0'});
                    noError = 'Minimum Quantity Cannot be 0';
                }
                if (!formData[i]['minimumQuantity']) {
                    noMinQtyObj.push({ index: i, errorMessage: 'Min. Qty. is required' });
                    noError = 'Please Enter Minimum Quantity';
                }
                if (formData[i]['maximumQuantity'] && !Number.isInteger(Number(formData[i]['maximumQuantity']))){
                    noMaxQtyObj.push({ index: i, errorMessage: 'Quantity Cannot be in Decimals' });
                    noError = 'Quantity Cannot be in Decimals';
                }
                if (formData[i]['minimumQuantity'] && !Number.isInteger(Number(formData[i]['minimumQuantity']))){
                    noMinQtyObj.push({ index: i, errorMessage: 'Quantity Cannot be in Decimals' });
                    noError = 'Quantity Cannot be in Decimals';
                }    
            }            
        }
        if (forTolerance!=1) {
            for (let i = formData.length - 1; i >= 0; i--) {
                minQty = formData[i]['minimumQuantity'];
                maxQty = formData[i]['maximumQuantity'];
                if (minQty && maxQty && (Number(minQty) >= Number(maxQty))) {
                    if(parseInt(maxQty) != -1){
                        minVsMaxErrorObj.push({ index: i, errorMessage: 'Maximum Qty. Cannot be Same or Less Than Minimum. Qty.' });
                        noError = 'Maximum Qty. Cannot be Same or Less Than Minimum. Qty.';
                    }
                }
            }
            for (let i = formData.length - 1; i >= 1; i--) {
                minQty = formData[i]['minimumQuantity'];
                maxQty = formData[i - 1]['maximumQuantity'];
                if (minQty && maxQty && (Number(minQty) <= Number(maxQty))) {
                    if(parseInt(maxQty) != -1){
                        qtyRangeErrorObj.push({ index: i, errorMessage: 'Quantity Should be in Ascending Order' });
                        noError = 'Quantity Should be in Ascending Order';
                    }
                }
            }    
        }                
        this.setState({errors:{ minVsMaxError: minVsMaxErrorObj, qtyRangeError: qtyRangeErrorObj, negSPError: negSPErrorObj, noMinQty: noMinQtyObj, noMaxQty: noMaxQtyObj, noDiscount: noDiscountObj, isTolerance: forTolerance }});
        return noError;
    }

    formSwitchHandler(formData){
        let negSPErrorObj = [], noError = '';
        for (let i = formData.length - 1; i >= 0; i--) {
            if (formData[i].sellingPrice == 0 || (formData[i].sellingPrice && (formData[i].sellingPrice <= 0))) {
                negSPErrorObj.push({ index: i, errorMessage: 'Quantity Should be in Ascending Order' });
                noError = 'Discounted Price Should be Greater than 0';
            }
        }
        this.setState({errors:{ negSPError: negSPErrorObj}});
        if(noError){
            this.props.showToastMessage({
                showToastMessage: true,
                message: noError,
                type: 'error',
                duration: 5000
            });
        }
    }

    calcEffectiveSP(index, key, value,fromSwitch) {
        let newmrp = value != undefined ? value : this.props.defaultPrice;
        let calcSP = 0;
        if(newmrp){
            if (key == 'fixedDiscount') {
                calcSP = Number(newmrp) - Number(this.state.sellOnlineFormData[index][key]);
            }
            else {
                calcSP = Number(newmrp) * ((100 - Number(this.state.sellOnlineFormData[index][key])) / 100);
            }
            let formDataForSP = this.state.sellOnlineFormData;
            formDataForSP[index]['sellingPrice'] = calcSP.toFixed(2);
            this.setState({ sellOnlineFormData: formDataForSP });
            this.props.updateSellOnlineFormData(formDataForSP);
            if(fromSwitch){
               this.formSwitchHandler(formDataForSP);
            }         
        }
        else{
            let formDataForSP = this.state.sellOnlineFormData;
            formDataForSP[index]['sellingPrice'] = this.props.variantPresent ? 0 : null;
            this.setState({ sellOnlineFormData: formDataForSP });
            this.props.updateSellOnlineFormData(formDataForSP);
            if(fromSwitch){
                this.formSwitchHandler(formDataForSP);
             }
        }
    }

    updateAllSp(value) {
        let key = this.state.discToggleIndex == 0 ? 'fixedDiscount' : 'percentageDiscount';
        for (let i = 0; i < this.state.sellOnlineFormData.length; i++) {
            this.calcEffectiveSP(i, key, value);
        }
    }

    checkError(row, col) {
        if (this.state.errors.minVsMaxError && (col == 0 || col == 1)) {
            for (let i = 0; i < this.state.errors.minVsMaxError.length; i++) {
                if (this.state.errors.minVsMaxError[i]['index'] == row) {
                    return true;
                }
            }
        }
        if (this.state.errors.noMinQty && col == 0) {
            for (let i = 0; i < this.state.errors.noMinQty.length; i++) {
                if (this.state.errors.noMinQty[i]['index'] == row) {
                    return true;
                }
            }
        }
        if (this.state.errors.noMaxQty && col == 1) {
            for (let i = 0; i < this.state.errors.noMaxQty.length; i++) {
                if (this.state.errors.noMaxQty[i]['index'] == row) {
                    return true;
                }
            }
        }
        if (this.state.errors.qtyRangeError && col == 0) {
            for (let i = 0; i < this.state.errors.qtyRangeError.length; i++) {
                if (this.state.errors.qtyRangeError[i]['index'] == row) {
                    return true;
                }
            }
        }
        if (this.state.errors.negSPError && ((!(this.state.errors?.isTolerance==1) && col == 2) || col == 3)) {            
            for (let i = 0; i < this.state.errors.negSPError.length; i++) {
                if (this.state.errors.negSPError[i]['index'] == row) {
                    return true;
                }
            }
        }
        if (this.state.errors.noDiscount && col == 2 ) {
            for (let i = 0; i < this.state.errors.noDiscount.length; i++) {
                if (this.state.errors.noDiscount[i]['index'] == row) {
                    return true;
                }
            }
        }
        return false;
    }

    deleteRange(index) {
        var tempArray = this.state.sellOnlineFormData;
        if (tempArray.length == 1) {
            this.setState({
                sellOnlineFormData: [{
                    minimumQuantity: this.props.variantPresent || this.props.viaOmni ? '' : tempArray[0]['minimumQuantity'],
                    maximumQuantity: '',
                    fixedDiscount: '',
                    percentageDiscount: '',
                    sellingPrice: this.props.variantPresent ? 0 : this.props.defaultPrice
                }]
            },()=>{
                this.props.updateSellOnlineFormData(this.state.sellOnlineFormData);
            });
            this.setState({maxQtyNotApplicable : false});
            this.props.handleMaxQty(false);
            return;
        }
        this.setState({ slideRangeUp: true });
        if(this.state.maxQtyNotApplicable){
            this.setState({maxQtyNotApplicable : !this.state.maxQtyNotApplicable},()=>{
                this.props.handleMaxQty(this.state.maxQtyNotApplicable);
            });
        }
        if(tempArray.length > 1){
            tempArray[tempArray.length-2]['disabled'] = false;
        }
        setTimeout(() => {
            tempArray.splice(index, 1);
            this.setState({
                sellOnlineFormData: tempArray,
                slideRangeUp: false
            });
            this.props.updateSellOnlineFormData(this.state.sellOnlineFormData);
        }, 300);
        let errorKeys = ['minimumQuantity', 'maximumQuantity', 'fixedDiscount', 'percentageDiscount'];
        for (let i = 0; i < errorKeys.length; i++) {
            this.clearErrors(errorKeys[i], index);
        }
    }


    inputGroups() {
        let formList = this.state.sellOnlineFormData;
        return (
            <div className={`${style['input-groups']} ${this.state.slideRangeUp ? 'slide-range-up ' : ''} ${formList.length == 4 ? 'no-more-btn' : ''}`}>
                {
                    Object.keys(formList).map((formData, index) => {
                        let isDisabled = !formList[0]['maximumQuantity'] && !formList[index]['fixedDiscount'] || formList.length -1 != index;
                        return (
                            <div className={`${style['single-group']} ${this.props.variantPresent ? style['with-variant'] : ''}`}>
                                <InputGroup
                                    className={`${style['quarter-input']} 
                                    ${this.checkError(index, 0) ? style['error'] : ''} ${this.props.isReadOnly ? 'read-only-mode' : ''}`}
                                    input={{
                                        type: this.props.deviceData.isIphone ? 'number' : 'tel',
                                        value: formList[index]['minimumQuantity'],
                                        onFocus: (e) => {
                                            if (e.currentTarget) {
                                                this.props.deviceData.isMobile && scrollIntoView(e.currentTarget, 'edit-product-form');
                                                this.clearErrors('minimumQuantity', index);
                                            }
                                        },
                                        onChange: (e) => this.rangeChangeHandler(e, index, 'minimumQuantity'),
                                        disabled: formList[index]['disabled'] && formList[index]['minimumQuantity'] || index !== 0,
                                    }}
                                />
                              <InputGroup
                                className={`${style['quarter-input']} ${this.checkError(index, 1) ? style['error'] : ''} ${this.props.isReadOnly ? 'read-only-mode' : ''}`}
                                input={{
                                    type: this.props.deviceData.isIphone ? 'tel' : 'tel',
                                    value: formList[index]['maximumQuantity'] === '-1' ? 'ထ' : formList[index]['maximumQuantity'],
                                    onFocus: (e) => {
                                        if (e.currentTarget) {
                                            this.props.deviceData.isMobile && scrollIntoView(e.currentTarget, 'edit-product-form');
                                            this.clearErrors('maximumQuantity', index);
                                        }
                                    },
                                    onChange: (e) => this.rangeChangeHandler(e, index, 'maximumQuantity'),
                                    disabled: formList[index]['disabled'],
                                }}
                                />
                                <InputGroup
                                className={`${style['quarter-input']} ${this.checkError(index, 2) ? style['error'] : ''} ${this.props.isReadOnly ? 'read-only-mode' : ''}`}
                                input={{
                                    type: this.props.deviceData.isIphone ? 'number' : 'tel',
                                    value: this.state.discToggleIndex === 0 ? formList[index]['fixedDiscount'] : formList[index]['percentageDiscount'],
                                    onFocus: (e) => {
                                        if (e.currentTarget) {
                                            this.props.deviceData.isMobile && scrollIntoView(e.currentTarget, 'edit-product-form');
                                            this.clearErrors('percentageDiscount', index);
                                        }
                                    },
                                    onChange: (e) =>
                                        this.rangeChangeHandler(e, index, this.discountTypes[this.state.discToggleIndex]),
                                }}
                                />
                                {this.props.variantPresent ? null : 
                                <div className={`${style['quarter-input']} 
                                ${style['selling-price-calc']} ${this.checkError(index, 3) ? style['error'] : ''}
                                ${this.props.isReadOnly ? 'read-only-mode' : ''}
                                `}>
                                    {formList[index].sellingPrice}
                                </div>}
                                {!this.props.isReadOnly ?  <div className={style['delete-range']+' '+(isDisabled?style['disabled-style']:'')} onClick={() => {!isDisabled ? this.deleteRange(index) : null}}>
                                    <span className='icon-trash'></span>
                                </div> : null}
                            </div>
                        )
                    })
                }
            </div>
        )
    }
    render() {
        let hideAddMore = this.state.maxQtyNotApplicable ? true : false;
        return (
            <div className={`${style['sell-online-container']}`}>
                <div className={`${style['sell-online-settings']} ${this.state.slideUp ? style['slide-up'] : ''}`}>
                    <div className={style['ranges-div']}>
                        <div className={`${style['label-list']} ${this.props.variantPresent ? style['with-variant'] : ''}`}>
                            <div className={`${style['sell-online-input-label']}`}>Minimum Qty.</div>
                            <div className={`${style['sell-online-input-label']}`}>Maximum Qty.</div>
                            <div className={`${style['sell-online-input-label']} ${style['discount']}`}>
                                Discount
                                {this.props.variantPresent ? 
                                        ' (%)' : <ToggleBtnGroup
                                    selectedValue={this.state.discToggleIndex}
                                    onToggle={(e, value) => {
                                        this.updateValue(e, value);
                                    }}
                                >
                                    <ToggleBtnGroup.Btn className={style['input-grp-btn']} value={0}>
                                        <i className='icon-currencyL'></i>
                                    </ToggleBtnGroup.Btn>
                                    <ToggleBtnGroup.Btn className={style['input-grp-btn']} value={1}>
                                        %
                                    </ToggleBtnGroup.Btn>
                                </ToggleBtnGroup>}
                            </div>
                            {this.props.variantPresent ? null : <div className={style['sell-online-input-label']}>
                                Price {this.props.unitOfMeasurement ? `/${this.props.unitOfMeasurement}` : ''}
                            </div>}
                        </div>
                        {this.inputGroups()}
                    </div>
                    <div className={`max-switch-holder pdb-5 ${this.props.isReadOnly ? 'read-only-mode' : ''}`}>
                        <FormSwitch
                            label='Max Qty. not Applicable for this Range'
                            checked={this.state.maxQtyNotApplicable || false}
                            labelPosition='before'
                            labelTitleClass='label-no-max-text fs-m'
                            onChange={() => this.handleMaxQtySwitch()}
                            className='input-row no-max-aty mgt-10'
                            showToggleStatus = {false}
                        />
                    </div>
                    {(this.state.sellOnlineFormData.length < 4) &&
                        <div className={`add-another-range ${hideAddMore ? 'disabled' : ''}
                            ${this.props.isReadOnly ? 'read-only-mode-add-another-range' : ' '}
                        `} onClick={!hideAddMore && !this.props.isReadOnly ? this.addRange : null}>
                            <span className='icon-plus'></span> Add Another Range
                        </div>
                    }
                </div>
                {/* <div className='fake-border'></div> */}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        deviceData: state.deviceData,
        permissions: state.permissions,
        // errors: state.items.errors,
        viaOmni:state.session.viaOmni,
        productData: state.products.editProduct,
        variantPresent: state.variants.variantProductData?.length > 0,
        isReadOnly: state.session.isReadOnly
    };
};
export default connect(mapStateToProps, {
    showToastMessage: toastMessageActions.showMessage
})(PriceRangeQty);
